// @angular
import { Injectable, inject, untracked} from "@angular/core";
import { Router, CanActivateFn } from "@angular/router";
import { toObservable } from "@angular/core/rxjs-interop";
import { take, map } from "rxjs";
// Own services
import { SessionDataService } from "./SessionDataService.service";
import { PROFILES } from "../../../assets/profiles/profiles";

/** Redirects `/principal` to the user's main page based on profile and settings. */
@Injectable({
  providedIn: "root"
})
export class MainRedirectGuardService {
  constructor(
    private readonly router: Router,
    private readonly SessionDataService: SessionDataService
  ) {}

  canActivate() {
    return toObservable(this.SessionDataService.userLogged).pipe(
      take(1),
      map(logged => {
        if (!logged) {
          this.router.navigate(["/acceso-denegado"]);
          return false;
        }

        // Check for a custom main page setting
        const customMainPage = untracked(() => this.SessionDataService.mainPage());
        if (customMainPage && customMainPage !== "/principal") {
          this.router.navigate([customMainPage]);
          return false;
        }

        // USUARIO_TELEMEDIDA: redirect to telemedida by default
        const currentProfile = untracked(() => this.SessionDataService.profile());
        if (currentProfile === PROFILES.USUARIO_TELEMEDIDA) {
          this.router.navigate(["/telecontrol/telemedida"]);
          return false;
        }

        // Other profiles go to the agrupation map
        this.router.navigate(["/principal-agrupacion"]);

        return false; // Avoid activating /principal since we redirect
      })
    );
  }
}

export const MainRedirectGuard: CanActivateFn = () => {
  return inject(MainRedirectGuardService).canActivate();
};
